








import { Component, Vue, Prop } from 'vue-property-decorator';
import { v1 } from 'uuid'
import LivePlayer from './components/LivePlayer.vue'
import Reply from './components/Replay.vue'
import Notice from './components/NoticeSlider.vue'
import { liveRoomTypeenum } from '@/common/enums'
import { getUserInfo } from 'apiUtils/Login'
import { getTimeGap } from '../../utils/index'

@Component({
  components: {
    LivePlayer,
    Reply,
    Notice
  },
})
export default class ZnPlayer extends Vue {
  private sid!: string
  private roomId!: string
  private userId!: string
  private userName = ''
  private userImg!: string
  private nickName!: string
  private loading = false
  private needAuth = true

  private created () {
    getTimeGap()
    this.getLoginInfo()
  }

  private getLoginInfo () {
    if (this.$route.params.sid) {
      this.sid = this.$route.params.sid as string
      this.roomId = this.$route.params.roomId as string
      this.userId = this.$route.params.userId as string
      this.getUserInfo()
      this.$store.dispatch('setSid', this.sid)
    } else {
      this.sid = this.$route.query.sid as string
      this.roomId = this.$route.query.roomId as string
      this.userId = "$ZNYOUKE@" + v1().replace(/-/g, '').slice(0, 20).toUpperCase() + "uid"
      this.nickName = '游客'
      this.userImg = 'http://hrmsv3-mlearning-stg5.pingan.com.cn:20083/learn/app/default1'
    }
  }

  private async getUserInfo () {
    this.loading = true
    const resp = await getUserInfo({
      sid: this.sid,
      nonGzip: 1
    })
    this.loading = false
    if (+resp.code === 0) {
      const { userName,
              userImg = 'http://hrmsv3-mlearning-stg5.pingan.com.cn:20083/learn/app/default1',
              nickName
            } = resp.body;
      this.userName = userName
      this.userImg = userImg
      this.nickName = nickName
      return;
    }

  }

  private get isLiveStream () {
    return (this.$route.params.liveRoomType || '1') as string === liveRoomTypeenum.LIVEING
  }
}
